import { Link } from 'react-router-dom';

const blogPosts = [
  {
    id: 'pharmacist-safety-check',
    title: "🚨 【命を守る目】薬剤師があなたのお薬手帳を見て「即、疑義照会！」する危険なサイン3選",
    excerpt: "複数の病院にかかっている方、複数の薬を服用している方へ。薬剤師が最後の砦として、あなたの命を守るために行っている重要なチェックポイントをご紹介します。重複投薬、相互作用、腎機能・肝機能への配慮不足など、見過ごせない危険なサインを詳しく解説。",
    date: "2025年11月16日",
    category: "医療安全",
    categoryColor: "bg-red-100 text-red-800",
    image: "https://public.readdy.ai/ai/img_res/2e53a9dfce3a81654bb6af576d1e9795.jpg",
    link: "/beast-blog/pharmacist-safety-check",
    isNew: true
  },
  {
    id: 'disaster-medication-management',
    title: "薬剤師が教える！災害時のお薬管理マニュアル",
    excerpt: "地震や台風などの災害時に命を守るカギとなる「薬の管理」について、薬剤師が詳しく解説。防災バッグに入れるべき薬のリスト、事前準備のポイント、緊急時の対処法まで包括的にお伝えします。",
    date: "2025年11月12日",
    category: "防災・緊急時対応",
    categoryColor: "bg-red-100 text-red-800",
    image: "https://readdy.ai/api/search-image?query=Emergency%20disaster%20preparedness%20medication%20management%20kit%20with%20medicine%20bottles%2C%20first%20aid%20supplies%2C%20emergency%20bag%2C%20and%20medical%20documents%20on%20clean%20white%20background%2C%20professional%20healthcare%20photography%20style%2C%20bright%20lighting%2C%20organized%20layout&width=400&height=250&seq=disaster-med-card&orientation=landscape",
    link: "/beast-blog/disaster-medication-management",
    isNew: true
  },
  {
    id: 'patient-pharmacy-vision',
    title: "患者のための薬局ビジョン",
    excerpt: "患者中心の薬局サービスが目指す未来像と、薬剤師の新たな役割について詳しく解説します。個別化医療、多職種連携、デジタル技術の活用など、現代薬局の進化を探ります。",
    date: "2025年11月8日",
    category: "薬局ビジョン",
    categoryColor: "bg-blue-100 text-blue-800",
    image: "https://readdy.ai/api/search-image?query=Modern%20pharmacy%20interior%20with%20pharmacist%20consulting%20patient%2C%20professional%20healthcare%20environment%2C%20bright%20lighting%2C%20clean%20white%20design%2C%20medical%20consultation%20area%2C%20patient-centered%20care%2C%20healthcare%20technology%20integration%2C%20warm%20and%20welcoming%20atmosphere&width=400&height=200&seq=patient-pharmacy-vision&orientation=landscape",
    link: "/beast-blog/patient-pharmacy-vision",
    isNew: true
  },
  {
    id: 'medical-plan-5diseases-6projects',
    title: "第８次医療計画の５疾病６事業について",
    excerpt: "地域完結型医療における薬局薬剤師のビジョンと役割について詳しく解説します。５疾病６事業を推進する中で、薬剤師が果たすべき重要な役割とは。",
    date: "2025年11月5日",
    category: "医療制度",
    categoryColor: "bg-purple-100 text-purple-800",
    image: "https://readdy.ai/api/search-image?query=Modern%20healthcare%20system%20with%20medical%20professionals%20collaborating%20in%20a%20bright%20hospital%20setting%2C%20showing%20doctors%2C%20nurses%20and%20pharmacists%20working%20together%20with%20digital%20health%20technology%2C%20clean%20white%20medical%20environment%20with%20blue%20accents%2C%20professional%20medical%20teamwork%20illustration&width=400&height=250&seq=medical-plan-card&orientation=landscape",
    link: "/beast-blog/medical-plan-5diseases-6projects",
    isNew: true
  },
  {
    id: 1,
    title: "インフルエンザ予防に薬局でできること｜薬剤師が教える最新対策",
    excerpt: "2025年最新のインフルエンザ対策を薬剤師が詳しく解説。ワクチン情報から市販薬の選び方、予防接種のタイミングまで包括的にお伝えします。",
    date: "2025年10月30日",
    category: "感染症対策",
    categoryColor: "bg-red-100 text-red-800",
    image: "https://readdy.ai/api/search-image?query=Professional%20pharmacist%20in%20modern%20pharmacy%20explaining%20influenza%20prevention%20methods%20with%20vaccine%20information%20and%20over-the-counter%20medicines%20displayed%2C%20educational%20healthcare%20setting%20with%20charts%20showing%20flu%20prevention%20strategies%2C%20warm%20lighting%2C%20Japanese%20pharmacy%20environment&width=400&height=250&seq=influenza-prevention-pharmacy&orientation=landscape",
    link: "/beast-blog/influenza-prevention-pharmacy"
  },
  {
    id: 2,
    title: "在宅医療における薬剤師の役割と支援内容をわかりやすく紹介",
    excerpt: "高齢化社会の進展とともに重要性が高まる在宅医療。その中で薬剤師が果たす役割と具体的な支援内容について詳しく解説します。",
    date: "2025年10月25日",
    category: "在宅医療",
    categoryColor: "bg-green-100 text-green-800",
    image: "https://readdy.ai/api/search-image?query=Professional%20pharmacist%20visiting%20elderly%20patient%20at%20home%2C%20providing%20medication%20consultation%20and%20support%2C%20warm%20and%20caring%20atmosphere%2C%20modern%20medical%20equipment%2C%20Japanese%20healthcare%20setting%2C%20bright%20natural%20lighting%2C%20professional%20healthcare%20environment&width=400&height=250&seq=home-medical-care-blog&orientation=landscape",
    link: "/beast-blog/home-medical-care-pharmacist"
  },
  {
    id: 3,
    title: "秋の花粉症対策｜春との違いとおすすめの薬・ケア方法",
    excerpt: "秋の花粉症は春とは原因や症状が異なります。ブタクサやヨモギが原因の秋の花粉症について、効果的な薬と対策方法を薬剤師が解説します。",
    date: "2025年10月20日",
    category: "花粉症対策",
    categoryColor: "bg-yellow-100 text-yellow-800",
    image: "https://readdy.ai/api/search-image?query=Autumn%20allergy%20season%20with%20ragweed%20and%20mugwort%20pollen%2C%20person%20with%20seasonal%20allergies%2C%20fall%20landscape%20with%20yellow%20and%20orange%20leaves%2C%20Japanese%20autumn%20scenery%2C%20healthcare%20and%20wellness%20theme&width=400&height=250&seq=autumn-allergy-blog&orientation=landscape",
    link: "/beast-blog/autumn-hay-fever-guide"
  },
  {
    id: 4,
    title: "かかりつけ薬剤師とは？メリットと登録方法を徹底解説",
    excerpt: "かかりつけ薬剤師制度について、そのメリットや登録方法、費用などを詳しく解説。あなたの健康管理をサポートする心強いパートナーです。",
    date: "2025年10月15日",
    category: "薬剤師制度",
    categoryColor: "bg-indigo-100 text-indigo-800",
    image: "https://readdy.ai/api/search-image?query=Professional%20pharmacist%20consultation%20with%20patient%2C%20friendly%20healthcare%20interaction%2C%20modern%20pharmacy%20setting%2C%20trust%20and%20care%2C%20Japanese%20healthcare%20environment%2C%20warm%20lighting%2C%20professional%20medical%20consultation&width=400&height=250&seq=family-pharmacist-blog&orientation=landscape",
    link: "/beast-blog/family-pharmacist-guide"
  },
  {
    id: 'supplement-drug-interactions',
    title: 'サプリメントと薬の飲み合わせは大丈夫？注意すべき組み合わせ一覧',
    excerpt: 'セントジョーンズワート、イチョウ葉エキス、ビタミン類など、薬との相互作用に注意が必要なサプリメントについて詳しく解説します。',
    date: '2025年10月08日',
    category: '薬学知識',
    categoryColor: 'bg-teal-100 text-teal-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20in%20modern%20pharmacy%20explaining%20supplement-drug%20interactions%20with%20various%20supplement%20bottles%20and%20prescription%20medicines%20displayed%20on%20consultation%20table%2C%20educational%20illustration%20showing%20warning%20signs%20about%20drug%20interactions%2C%20professional%20healthcare%20setting%20with%20charts%20showing%20supplement%20safety%20information%2C%20friendly%20cartoon%20style%20with%20detailed%20pharmacy%20background&width=400&height=250&seq=beast-supplement-drug-interactions-card&orientation=landscape',
    link: '/beast-blog/supplement-drug-interactions'
  },
  {
    id: 'drug-food-interactions',
    title: '薬の飲み合わせで注意すべき食べ物10選【薬剤師監修】',
    excerpt: '薬と食べ物の相互作用について、薬剤師が詳しく解説。グレープフルーツ、牛乳、アルコールなど、特に注意が必要な食べ物10選をご紹介します。',
    date: '2025年10月07日',
    category: '薬学知識',
    categoryColor: 'bg-teal-100 text-teal-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20in%20modern%20pharmacy%20explaining%20drug-food%20interactions%20with%20various%20foods%20and%20medicines%20displayed%20on%20table%2C%20educational%20illustration%20showing%20different%20foods%20like%20grapefruit%20milk%20coffee%20and%20various%20medicine%20bottles%2C%20professional%20healthcare%20setting%20with%20warning%20charts%20about%20food-drug%20interactions%2C%20friendly%20cartoon%20style%20with%20detailed%20pharmacy%20background&width=400&height=250&seq=beast-drug-food-interactions-card&orientation=landscape',
    link: '/beast-blog/drug-food-interactions'
  },
  {
    id: 'medicine-not-working',
    title: '薬が効かないときの原因5選｜飲み方・生活習慣・相互作用をチェック',
    excerpt: '薬の効果が感じられない時に確認すべきポイントを薬剤師が詳しく解説。服用方法、相互作用、生活習慣など5つの主要原因と対処法をお伝えします。',
    date: '2025年10月06日',
    category: '薬学知識',
    categoryColor: 'bg-teal-100 text-teal-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20explaining%20why%20medicines%20don%5C%5Ct%20work%20effectively%2C%20educational%20illustration%20with%20medicine%20bottles%20and%20warning%20signs%2C%20concerned%20expression%2C%20professional%20healthcare%20setting%20with%20charts%20showing%20medication%20problems&width=400&height=250&seq=beast-medicine-not-working-card&orientation=landscape',
    link: '/beast-blog/medicine-not-working'
  },
  {
    id: 'generic-medicine',
    title: 'ジェネリック医薬品とは？違い・メリット・デメリットを薬剤師が解説',
    excerpt: '先発医薬品との違いやオーソライズドジェネリックについても詳しく解説。経済的メリットと注意点を薬剤師の視点から説明します。',
    date: '2025年10月05日',
    category: '薬学知識',
    categoryColor: 'bg-teal-100 text-teal-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20in%20modern%20pharmacy%20explaining%20generic%20medicine%20differences%20with%20comparison%20charts%20and%20medicine%20bottles%2C%20professional%20educational%20setting%20with%20clear%20visual%20aids%20showing%20cost%20savings%20and%20pharmaceutical%20equivalence%2C%20friendly%20cartoon%20style%20with%20detailed%20pharmacy%20background&width=400&height=250&seq=beast-generic-medicine-card-v2&orientation=landscape',
    link: '/beast-blog/generic-medicine'
  },
  {
    id: 'multidisciplinary-collaboration',
    title: '薬剤師目線での多職種連携について',
    excerpt: '在宅医療における薬剤師の役割と、在宅医、訪問看護師、ケアマネージャー、言語聴覚士などとの効果的な連携方法について詳しく解説します。',
    date: '2025年10月04日',
    category: '多職種連携',
    categoryColor: 'bg-indigo-100 text-indigo-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20collaborating%20with%20healthcare%20team%20including%20doctors%20nurses%20and%20therapists%2C%20professional%20medical%20meeting%20scene%2C%20cartoon%20illustration%20style%2C%20teamwork%20in%20healthcare%20setting&width=400&height=250&seq=beast-blog-multidisciplinary&orientation=landscape',
    link: '/beast-blog/multidisciplinary-collaboration'
  },
  {
    id: 'winter-mental-health',
    title: '冬季のメンタルヘルス対策について',
    excerpt: '冬季うつ病（SAD）の症状と対策、光療法の効果、ビタミンDの重要性について、薬剤師の視点から詳しく解説します。',
    date: '2025年10月03日',
    category: 'メンタルヘルス',
    categoryColor: 'bg-blue-100 text-blue-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20in%20cozy%20winter%20pharmacy%20setting%20explaining%20seasonal%20depression%20care%2C%20warm%20indoor%20lighting%20with%20snow%20visible%20through%20windows%2C%20educational%20illustration%20about%20winter%20mental%20health%20and%20vitamin%20D%20supplements%2C%20friendly%20cartoon%20style%20with%20seasonal%20wellness%20theme&width=400&height=250&seq=beast-winter-mental-health-card-v2&orientation=landscape',
    link: '/beast-blog/winter-mental-health'
  },
  {
    id: 'otc-selection',
    title: '市販薬選びで失敗しないコツ',
    excerpt: '薬局でよく聞かれる市販薬の選び方について、実際の相談事例を交えながらわかりやすく説明します。症状別の選び方のポイントも解説。',
    date: '2025年10月02日',
    category: 'OTC医薬品',
    categoryColor: 'bg-purple-100 text-purple-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20in%20pharmacy%20setting%20explaining%20OTC%20medicines%2C%20cartoon%20illustration%20with%20medicine%20shelves%20and%20friendly%20consultation%20scene%2C%20educational%20healthcare%20content&width=400&height=250&seq=beast-blog-otc&orientation=landscape',
    link: '/beast-blog/otc-selection'
  },
  {
    id: 'health-management',
    title: '薬剤師が教える筋トレと健康管理',
    excerpt: '薬学知識と筋トレ経験を活かした、効果的な健康管理方法をお伝えします。サプリメントの正しい使い方も詳しく解説。',
    date: '2025年10月01日',
    category: '健康管理',
    categoryColor: 'bg-green-100 text-green-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20demonstrating%20exercise%20and%20health%20tips%2C%20cartoon%20illustration%20showing%20workout%20and%20wellness%20advice%2C%20friendly%20educational%20content%2C%20colorful%20gym%20and%20pharmacy%20background&width=400&height=250&seq=beast-blog-health&orientation=landscape',
    link: '/beast-blog/health-management'
  },
  {
    id: 'effective-medication',
    title: '薬の効果的な飲み方とタイミング',
    excerpt: '薬の効果を最大限に引き出すための正しい服用方法について、筋トレの経験も交えながら解説します。食前・食後の違いや相互作用についても詳しく説明します。',
    date: '2025年09月30日',
    category: '薬学知識',
    categoryColor: 'bg-teal-100 text-teal-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20explaining%20medicine%20effects%2C%20educational%20illustration%20with%20charts%20and%20diagrams%2C%20friendly%20cartoon%20style%2C%20professional%20healthcare%20setting%2C%20colorful%20and%20engaging%20visual&width=400&height=250&seq=beast-blog-medication&orientation=landscape',
    link: '/beast-blog/effective-medication'
  },
  {
    id: 'elderly-medication-management',
    title: '高齢者の薬物療法管理｜安全な服薬のポイント',
    excerpt: '高齢者特有の薬物動態の変化と、安全で効果的な薬物療法のポイントを薬剤師が解説します。',
    date: '2025年09月25日',
    category: '高齢者ケア',
    categoryColor: 'bg-amber-100 text-amber-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20consulting%20with%20elderly%20patient%20about%20medication%20management%2C%20warm%20and%20caring%20consultation%20scene%2C%20professional%20healthcare%20setting%20with%20pill%20organizers%20and%20medication%20charts%2C%20friendly%20cartoon%20style&width=400&height=250&seq=beast-elderly-medication&orientation=landscape',
    link: '/beast-blog/elderly-medication-management'
  },
  {
    id: 'constipation-medicine-guide',
    title: '便秘薬の正しい選び方と使い方｜薬剤師が教える便秘解消法',
    excerpt: '便秘の種類別に適した薬の選び方と、生活習慣の改善方法について薬剤師が詳しく解説します。',
    date: '2025年09月20日',
    category: 'OTC医薬品',
    categoryColor: 'bg-purple-100 text-purple-800',
    image: 'https://readdy.ai/api/search-image?query=Muscular%20anime%20pharmacist%20character%20with%20black%20two-block%20haircut%20explaining%20constipation%20medicines%20and%20digestive%20health%2C%20educational%20illustration%20with%20various%20laxative%20types%20and%20healthy%20lifestyle%20tips%2C%20professional%20pharmacy%20setting%2C%20friendly%20cartoon%20style&width=400&height=250&seq=beast-constipation-medicine&orientation=landscape',
    link: '/beast-blog/constipation-medicine-guide'
  }
];

const categories = [
  { name: '全て', count: blogPosts.length, active: true },
  { name: '薬学知識', count: 5, active: false },
  { name: '健康管理', count: 1, active: false },
  { name: 'OTC医薬品', count: 2, active: false },
  { name: 'メンタルヘルス', count: 1, active: false },
  { name: '多職種連携', count: 1, active: false },
  { name: '高齢者ケア', count: 1, active: false }
];

export default function BeastBlogPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-orange-600" style={{ fontFamily: '"Pacifico", serif' }}>
                logo
              </a>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-orange-600 transition-colors">ホーム</a>
              <a href="/services" className="text-gray-700 hover:text-orange-600 transition-colors">サービス</a>
              <a href="/beast-blog" className="text-orange-600 font-medium">ビースト君ブログ</a>
              <a href="/information" className="text-gray-700 hover:text-orange-600 transition-colors">お知らせ</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-orange-50 to-amber-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex justify-center items-center mb-6">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mr-4">
                <i className="ri-bear-smile-line text-2xl text-white"></i>
              </div>
              <h1 className="text-4xl font-bold text-gray-900">ビースト君ブログ</h1>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              薬剤師のビースト君が、薬学の知識や健康に関する情報を分かりやすくお届けします。
              最新の医療情報から日常の健康管理まで、皆様の健康をサポートする情報が満載です。
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map((post) => (
              <article key={post.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center gap-2 text-sm text-gray-500 mb-2">
                    <i className="ri-calendar-line"></i>
                    <span>{post.date}</span>
                    {post.isNew && (
                      <span className="bg-orange-100 text-orange-800 px-2 py-1 rounded text-xs">新着</span>
                    )}
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-gray-800">
                    <Link to={post.link} className="hover:text-orange-600 transition-colors">
                      {post.title}
                    </Link>
                  </h3>
                  <p className="text-gray-600 text-sm mb-4">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${post.categoryColor || 'bg-gray-100 text-gray-800'}`}>
                      {post.category}
                    </span>
                    <Link to={post.link} className="text-orange-600 hover:text-orange-800 font-medium text-sm">
                      続きを読む →
                    </Link>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>logo</h3>
              <p className="text-gray-400">
                薬剤師による信頼できる健康情報をお届けします
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">サービス</h4>
              <ul className="space-y-2">
                <li><a href="/services" className="text-gray-400 hover:text-white transition-colors">サービス一覧</a></li>
                <li><a href="/health-consultation" className="text-gray-400 hover:text-white transition-colors">健康相談</a></li>
                <li><a href="/otc" className="text-gray-400 hover:text-white transition-colors">OTC医薬品</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">情報</h4>
              <ul className="space-y-2">
                <li><a href="/beast-blog" className="text-gray-400 hover:text-white transition-colors">ビースト君ブログ</a></li>
                <li><a href="/information" className="text-gray-400 hover:text-white transition-colors">お知らせ</a></li>
                <li><a href="/pharmacist-resources" className="text-gray-400 hover:text-white transition-colors">薬剤師向け情報</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
              <p className="text-gray-400 mb-4">📧 pharmabeast.k@gmail.com</p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <i className="ri-twitter-line text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <i className="ri-facebook-line text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <p className="text-gray-400">
              © 2024 薬剤師サポートサイト. All rights reserved. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors ml-1">Website Builder</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
